/**
 * Système de déduplication des notifications
 * Utilisé pour éviter les doublons entre push FCM et polling in-app
 */

const STORAGE_KEY = 'seenNotifTags';
const MAX_TAGS = 200;

/**
 * Récupère tous les tags vus
 */
function getSeenTags() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * Sauvegarde les tags vus (max 200, FIFO)
 */
function saveSeenTags(tags) {
  try {
    const limited = tags.slice(-MAX_TAGS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(limited));
  } catch {
    // no-op
  }
}

/**
 * Vérifie si un tag a déjà été vu
 */
export function isSeen(tag) {
  if (!tag) return false;
  const tags = getSeenTags();
  return tags.includes(tag);
}

/**
 * Marque un tag comme vu
 */
export function markSeen(tag) {
  if (!tag) return;
  const tags = getSeenTags();
  if (!tags.includes(tag)) {
    tags.push(tag);
    saveSeenTags(tags);
  }
}

/**
 * Calcule le tag unique d'un événement duel
 * @param {Object} duel - Le duel
 * @param {string} userId - ID de l'utilisateur actuel
 * @returns {string|null} Le tag unique ou null
 */
export function calculateDuelTag(duel, userId) {
  if (!duel || !userId) return null;

  const isAttacker = duel.attacker_user_id === userId;
  const isDefender = duel.defender_user_id === userId;
  const role = isAttacker ? 'attacker' : (isDefender ? 'defender' : null);

  if (!role) return null;

  const { status, id, winner_user_id } = duel;

  // Duel reçu (PENDING_ACCEPT)
  if (status === 'PENDING_ACCEPT' && role === 'defender') {
    return `duel_${id}_received`;
  }

  // Duel accepté
  if (status === 'ACTIVE' && role === 'attacker') {
    return `duel_${id}_accepted`;
  }

  // Score soumis
  if (status === 'SCORE_SUBMITTED' && duel.score_submitted_by_user_id !== userId) {
    return `duel_${id}_score_submitted`;
  }

  // Duel terminé
  if (status === 'COMPLETED') {
    // Distinction gagnant/perdant
    if (winner_user_id === userId) {
      return `duel_${id}_win`;
    } else if (winner_user_id) {
      return `duel_${id}_loss`;
    }
    return `duel_${id}_completed`;
  }

  // Duel annulé/expiré
  if (status === 'CANCELLED') {
    return `duel_${id}_expired`;
  }

  return null;
}

/**
 * Calcule le tag d'une annonce admin
 */
export function calculateAdminAnnounceTag(announcementId) {
  return `admin_announce_${announcementId}`;
}